// @ts-nocheck
import { getApiHost, logout } from '@/utils/auth';
import config from '@/utils/config';
import Helper from "@/utils/helper";
import * as Enums from '@/utils/enums';
import Storage from '@/utils/storage';

async function request(url: any, params: any, method: any, ctx: any, toastCtx: any, czTenantID: any, czCustomerID: any, apiUrlOverride: any, caller: any, signal: any, statusIfNull: any) {

  const isSSR = typeof window === 'undefined';

  const options: any = {
    method,
    headers: getHeaders(),
    signal: signal // abort signal
  };

  if (isSSR) {
    const https = require("https");
    options.agent = new https.Agent({
      rejectUnauthorized: !config.isDebugging()
    });
  }

  if (params) {
    if (method === 'GET') {
      url += '?' + Helper.objectToQueryString(params);
    } else {
      options.body = JSON.stringify(params);
    }
  }

  function getHeaders() {
    let path = "";
    if (typeof window !== "undefined") {
      path = window.location.href;
    } else if (ctx) {
      path = ctx.req.headers.referer || `http://${ctx.req.headers.host}/login?token_expired=true&message=`;
    }

    caller = caller ? caller : "";

    if (czTenantID && !czCustomerID) {
      return {
        'cache': 'no-store',
        'tenantid': czTenantID,
        'Content-Type': 'application/json',
        'location': path,
        'caller': caller
      };
    } else if (czTenantID && czCustomerID) {
      return {
        'cache': 'no-store',
        'tenantid': czTenantID,
        'customerid': czCustomerID,
        'Content-Type': 'application/json',
        'location': path,
        'caller': caller
      };
    } else {
      const localToken = Storage.getCookie(Enums.Cookie.token);
      const localTenantID = Storage.getCookie(Enums.Cookie.tenantID);
      const localDeviceID = Storage.getCookie(Enums.Cookie.fingerPrint);
      const { token, tenantID, fingerPrint } = { token: localToken, tenantID: localTenantID, fingerPrint: localDeviceID };

      return {
        'cache': 'no-store',
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json',
        'tenantid': tenantID,
        'deviceid': fingerPrint,
        'location': path,
        'caller': caller
      };
    }
  }

  let apiHost = getApiHost(ctx, apiUrlOverride);

  const response = await fetch(apiHost + url, options as any)
    .catch((e: any) => {
      let eString = e?.toString() ?? "";

      if (eString.indexOf("reason: getaddrinfo ENOTFOUND") > -1) {
        logout(true, ctx, "Server unavailable, retry login");
      }

      throw e;
    });

  if (response.status === 401) {
    let logoutMessage = await response.text();
    if (isSSR) {
      console.log(`[SSR Fetch] *** 401 UNAUTHORIZED on ${method} ${url} — logoutMessage: ${logoutMessage}`);
    }
    logout(true, ctx, logoutMessage);
    return { ResponseStatus: response.status, Results: [], Result: {}, TotalResults: 0 };
  }

  if (response.status !== 200 && response.status !== 204) {

    let serverMessage: string | null = null;
    try {
      serverMessage = await response.text();
    } catch { }

    // Try to parse serverMessage if it contains JSON (common API error envelope)
    const parsed = Helper.parseString(serverMessage);

    if (toastCtx) {
      toastCtx.setToast({
        message: parsed?.Message
          ? parsed.Message
          : (serverMessage ? serverMessage : 'The server responded with an unexpected status. (' + response.status + ')'),
        show: true,
        type: 'error'
      })
    }

    const errObj: any = {
      status: response.status,
      message: 'The server responded with an unexpected status. (' + response.status + ')',
      serverMessage: serverMessage
    };

    if (isSSR) {
      console.log(`[SSR Fetch] *** ERROR on ${method} ${url} | status: ${response.status} | serverMessage: ${(serverMessage || '').substring(0, 500)}`);
    }

    // Promote known fields from parsed server error so callers can rely on them
    if (parsed && typeof parsed === 'object') {
      if (parsed.HttpStatusCode !== undefined) errObj.HttpStatusCode = parsed.HttpStatusCode;
      if (parsed.Message !== undefined) errObj.Message = parsed.Message;
      if (parsed.ResponseStatus !== undefined) errObj.ResponseStatus = parsed.ResponseStatus;
      if (parsed.TotalResults !== undefined) errObj.TotalResults = parsed.TotalResults;
      if (parsed.ReturnedResults !== undefined) errObj.ReturnedResults = parsed.ReturnedResults;
      if (parsed.Results !== undefined) errObj.Results = parsed.Results;
      if (parsed.Result !== undefined) errObj.Result = parsed.Result;
      if (parsed.Metadata !== undefined) errObj.Metadata = parsed.Metadata;
    }

    return errObj;
  }

  const data = response.status === 204 ? "" : await response.text();
  let json = Helper.parseString(data);
  if (statusIfNull && !!!json) {
    json = {
      ResponseStatus: response.status
    };
  }

  const keys = json ? Object.keys(json) : [];
  if (keys.includes("headerTenantName") && keys.includes("data")) {
    // need to clean up the response and append headerTenantName to the data object
    let newJson = json.data;
    if (!!newJson && typeof newJson === "object") newJson.headerTenantName = json.headerTenantName;
    json = newJson;
  }

  if (json && json.SubscriptionInfo !== undefined && json.SubscriptionInfo !== null) {
    Storage.setCookie(Enums.Cookie.subscriptionInfo, json.SubscriptionInfo);
  }

  // if (options.headers.tenantid) {
  //   if (json) {
  //     if (json.TenantID) receivedTenantID = json.TenantID;
  //     else if (json.Result && json.Result.TenantID) receivedTenantID = json.Result.TenantID;
  //     else if (json.Results && json.Results.length > 0 && json.Results[0].TenantID) receivedTenantID = json.Results[0].TenantID;

  //     if (!Helper.isNullOrWhitespace(receivedTenantID) && receivedTenantID !== Helper.emptyGuid() && options.headers.tenantid.toLowerCase() !== receivedTenantID.toLowerCase()) {
  //       // we have a tenantid mismatch
  //       // alert server of this issue
  //         ctx, toastCtx, czTenantID, czCustomerID, apiUrlOverride);

  return json;
}

interface RequestObject {
  url: string
  params?: any
  ctx?: any
  toastCtx?: any
  tenantID?: string
  customerID?: string
  apiUrlOverride?: string
  caller?: string
  signal?: any
  statusIfNull?: boolean
}

function get({ url, params, ctx, toastCtx, tenantID, customerID, apiUrlOverride, caller, signal, statusIfNull = false }: RequestObject) {
  return request(url, params, 'GET', ctx, toastCtx, tenantID, customerID, apiUrlOverride, caller, signal, statusIfNull);
}

function post({ url, params, ctx, toastCtx, tenantID, customerID, apiUrlOverride, caller, signal, statusIfNull = false }: RequestObject) {
  return request(url, params, 'POST', ctx, toastCtx, tenantID, customerID, apiUrlOverride, caller, signal, statusIfNull);
}

function put({ url, params, ctx, toastCtx, tenantID, customerID, apiUrlOverride, caller, signal, statusIfNull = false }: RequestObject) {
  return request(url, params, 'PUT', ctx, toastCtx, tenantID, customerID, apiUrlOverride, caller, signal, statusIfNull);
}

function destroy({ url, params, ctx, toastCtx, tenantID, customerID, apiUrlOverride, caller, signal, statusIfNull = false }: RequestObject) {
  return request(url, params, 'DELETE', ctx, toastCtx, tenantID, customerID, apiUrlOverride, caller, signal, statusIfNull);
}

async function preLogin({ userName, password, tenantID, managerServCraftLoginCredentials, toastCtx }: any) {

  const isSSR = typeof window === 'undefined';

  const opts: any = {
    method: "POST",
    body: JSON.stringify({
      userName,
      password,
      customerID: tenantID,
      managerServCraftLoginCredentials: managerServCraftLoginCredentials
    }),
    headers: {
      'Content-Type': 'application/json'
    }
  };

  if (isSSR) {
    const https = require("https");
    opts.agent = new https.Agent({
      rejectUnauthorized: !config.isDebuggingManager()
    });
  }

  const response = await fetch(config.managerHost + "/Authentication/PreLogin", opts);

  if (response.status === 401) {
    logout(true);
  }

  if (response.status !== 200) {
    if (toastCtx) {
      toastCtx.setToast({
        message: 'The server responded with an unexpected status. (' + response.status + ')',
        show: true,
        type: 'error'
      })
    }

    return {
      status: response.status,
      message: 'The server responded with an unexpected status. (' + response.status + ')'
    };
  }

  const data = await response.text();
  const json = (data.length ? JSON.parse(data) : { ResponseStatus: response.status });

  return json;
}


//   // let origin = window ? window.location.origin : "";
//   // if (origin === "file://") {
//   //     origin = "http://test.com";
//   // }
// };


//           servcraftorigin: generic_GetOrigin(),
//           servcraftkey: key
//       };

//       method,
//       headers: getHeaders()
//   };

//   if (params) {
//       if (method === 'GET') {
//           url += '?' + generic_ObjectToQueryString(params, true);
//       } else {


//   try {
//   } catch (error) {
//           status: -1,
//           message: `Try Catch ${error}`,
//           serverMessage: "Fail",
//           data: null

//   if (response.status !== 200) {

//       try {
//       } catch { }

//           status: response.status,
//           message: `The server responded with an unexpected status. (${response.status})`,
//           serverMessage: serverMessage,
//           data: null
//       };


//       status: response.status,
//       message: `Success ${response.status}`,
//       serverMessage: "Success",
//       data: json
//   };
// };

// };

// };


export default {
  get,
  post,
  put,
  destroy,
  preLogin,
  // generic_Post,
  // generic_Get
};
